import ApiRoutes from "api/apiRoutes";
import { exeRequest } from "http/requestConfig";

export default class AreaService {

    static getAll(options, sCallBack, eCallBack) {
        ApiRoutes.areasResource.resourceOptions = Object.assign({}, ApiRoutes.areasResource.resourceOptions, options);
        exeRequest(ApiRoutes.areasResource, {}, sCallBack, eCallBack)
    }
}